import request from '@/utils/request'

const BaseUrl = '/resourceApply'

// 资源申请新增或修改
export function addApplication(data) {
  return request({
    url: `${BaseUrl}/save`,
    method: 'post',
    data
  })
}

export function updateApplication(data) {
  return request({
    url: `${BaseUrl}/update`,
    method: 'put',
    data
  })
}

// 资源申请删除
export function deleteApplicationById(id) {
  return request({
    url: `${BaseUrl}/delete/${id}`,
    method: 'delete',
  })
}

// 资源申请详情
export function ApplicationDetails(id) {
  return request({
    url: `${BaseUrl}/${id}`,
    method: 'get',
  })
}

// /resourceApply/getSkillRank
export function getSkillRank(params) {
  return request({
    url: `${BaseUrl}/getSkillRank`,
    method: 'get',
    params
  })
}

export function reviewResourceApply(data) {
  return request({
    url: `${BaseUrl}/reviewResourceApply`,
    method: 'post',
    data
  })
}

